import React from "react";
import { inject, observer } from "mobx-react";
import Header from "../../sharedComponents/header/header";
import { ProposalStore } from "../../../stores/proposalStore";
import DropDown from "../../sharedComponents/dropDown/dropDown";
import {
  DirectPaymentMethodDropDown,
  DistancePaymentMethodDropDown,
  filterAllowedPaymnetMethods,
  getValidPaymentMethod,
  PaymentMethodDropDown,
  PaymentMethodTypes
} from "../../../helpers/paymentMethod";
import { UiFlagsStore } from "../../../stores/uiFlagsStore";
import { DictionariesStore } from "../../../stores/dictionariesStore";
import { DatePicker } from "@material-ui/pickers";
import { UserRole } from "../../../helpers/userRole";
import { UserStore } from "../../../stores/userStore";
import { addDays } from "date-fns";
import { CalculateStore } from "../../../stores/calculateStore";

interface PaymentMethodProps {
  dictionariesStore?: DictionariesStore;
  proposalStore?: ProposalStore;
  uiFlagsStore?: UiFlagsStore;
  userStore?: UserStore;
  calculateStore?: CalculateStore;
}

interface PaymentMethodState {
  displayPaymentToDate: boolean;
}

@inject("proposalStore", "uiFlagsStore", "dictionariesStore", "userStore", "calculateStore")
@observer
export default class PaymentMethod extends React.Component<PaymentMethodProps, PaymentMethodState> {

  constructor(props: any) {
    super(props);

    this.state = {
      displayPaymentToDate: false
    };
  }
  public componentDidMount() {
    this.setPaymentMethod();
  }

  private setPaymentMethod() {
    const { uiFlagsStore, proposalStore, dictionariesStore } = this.props;

    if(uiFlagsStore!.isDirect) {
      this.handlePaymentMethodChange(PaymentMethodTypes.PAYU);
    } else if (proposalStore!.distancePolicy.value) {
      this.handlePaymentMethodChange(PaymentMethodTypes.TRANSFER);
    } else {
      const validPaymentMethod = getValidPaymentMethod(proposalStore!.paymentMethod, dictionariesStore!.paymentMethods);
      this.handlePaymentMethodChange(validPaymentMethod);
    }
    this.setUserPaymentMaxDate();
  }
  private onPaymentToDateChange(date: Date | null) {
    if (date) {
      this.props.proposalStore?.setPaymentToDate(date);
    }
  }

  public render() {
    const paymentToDate = this.props.proposalStore?.paymentToDate;
    const userPaymentMaxDate = this.getUserPaymentMaxDate();
    const minDate = addDays(new Date(), 1);
    return (
      <div className="section payment-method">
        <Header type="medium" mainHeader={this.paymentMethod().label} />
        <div className="question-answer-container">
          <div className="question">Forma płatności</div>
          <DropDown
            onChange={(value) => this.handlePaymentMethodChange(value)}
            value={this.props.proposalStore!.paymentMethod}
            items={this.paymentMethod().dropDown}
            errorMessage={this.getErrorMessage()}
          />
        </div>
        {this.state.displayPaymentToDate && <div className="question-answer-container">
          <div className="question">Data płatności</div>
          <div className="date">
            <div className="payment-date">
              <DatePicker className="payment-date-picker text-input"
                          variant="inline"
                          format="yyyy-MM-dd"
                          value={paymentToDate ? paymentToDate : userPaymentMaxDate}
                          minDate={minDate}
                          maxDate={userPaymentMaxDate}
                          onChange={(value) => this.onPaymentToDateChange(value)}
              />
            </div>
          </div>
        </div>}
      </div>
    );
  }

  private handlePaymentMethodChange(paymentMethod: PaymentMethodTypes) {
    this.props.proposalStore!.setPaymentMethod(paymentMethod);
    if (this.shouldDisplayPaymentDatePicker(paymentMethod)) {
      this.setState({ displayPaymentToDate: true });
    } else if (this.shouldHidePaymentDatePickerIfNeeded(paymentMethod)) {
      this.props.proposalStore?.resetPaymentToDate();
      this.setState({ displayPaymentToDate: false });
    }
  }

  private shouldHidePaymentDatePickerIfNeeded(paymentMethod: PaymentMethodTypes) {
    return this.state.displayPaymentToDate && paymentMethod !== PaymentMethodTypes.TRANSFER;
  }

  private shouldDisplayPaymentDatePicker(paymentMethod: PaymentMethodTypes) {
    return paymentMethod === PaymentMethodTypes.TRANSFER &&
      !this.props.uiFlagsStore!.isDirect && !this.state.displayPaymentToDate;
  }

  private getUserPaymentMaxDate(): Date {
    const todayDate = new Date();
    if (UserRole.isEurofinanceRole(this.props.userStore!.roles) || UserRole.isSolidRole(this.props.userStore!.roles)) {
      if (this.isMoreThan30DaysFromStartOfInsuranceEurofinanceAndSolidOnly(todayDate)) {
        return this.props.calculateStore!.additionalQuestions.startDate;
      }
      return addDays(todayDate, 30);
    }
    return addDays(todayDate, 14);
  }

  private isMoreThan30DaysFromStartOfInsuranceEurofinanceAndSolidOnly(todayDate: Date) {
    return this.props.calculateStore!.additionalQuestions.startDate > addDays(todayDate, 30);
  }

  private setUserPaymentMaxDate() {
    const userPaymentMaxDate = this.getUserPaymentMaxDate();
    this.props.proposalStore?.setPaymentToDate(userPaymentMaxDate);
  }

  private paymentMethod() {
    const selectedPaymentMethodDropDown = this.selectPaymentMethodDropDown();
    const allowedPaymentMethods = this.props.dictionariesStore!.paymentMethods;
    return filterAllowedPaymnetMethods(selectedPaymentMethodDropDown, allowedPaymentMethods);
  }

  private selectPaymentMethodDropDown() {
    if (this.props.uiFlagsStore!.isDirect) {
      return DirectPaymentMethodDropDown;
    } else if (this.props.proposalStore!.distancePolicy.value) {
      return DistancePaymentMethodDropDown;
    }
    return PaymentMethodDropDown;
  }

  private getErrorMessage() {
    const proposalStore = this.props.proposalStore!;

    return proposalStore.distancePolicy.value && proposalStore.paymentMethod === PaymentMethodTypes.CASH ?
      "Płatność gotówką niedostępna dla polisy na odległość"
      : "";
  }

}
